export const UPDATE_MARKETS = "UPDATE_MARKETS";

export function setMainMarkets(mainMarkets) {
  return {
    type: UPDATE_MARKETS,
    payload: mainMarkets.reverse()
  };
}
